import { render, staticRenderFns } from "./PasswordResetInstructions.vue?vue&type=template&id=58f67243&scoped=true"
import script from "./PasswordResetInstructions.vue?vue&type=script&lang=js"
export * from "./PasswordResetInstructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f67243",
  null
  
)

export default component.exports